"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function useAutoComplete(params) {
    var _a = params.initIsShowResult, initIsShowResult = _a === void 0 ? false : _a, getSelectedResultFn = params.getSelectedResultFn, autoCompleteRef = params.autoCompleteRef, valueResultList = params.valueResultList, onChange = params.onChange, setValueFn = params.setValueFn;
    var _b = react_1.default.useState(initIsShowResult), isShowResult = _b[0], setShowResult = _b[1];
    var _c = react_1.default.useState(), selectedResult = _c[0], setSelectedResult = _c[1];
    var handleShowResult = react_1.useCallback(function () {
        if (valueResultList.length > 0) {
            setShowResult(true);
        }
        else {
            setShowResult(false);
        }
    }, [valueResultList.length]);
    var handleSelectResultDirectly = react_1.useCallback(function (valueResult) {
        setValueFn && setValueFn(valueResult.value, valueResult.result);
        getSelectedResultFn && getSelectedResultFn(valueResult);
        setSelectedResult(valueResult);
        setShowResult(false);
    }, [getSelectedResultFn, setValueFn]);
    var handleSelectResult = react_1.useCallback(function (index) {
        return function () {
            if (isShowResult) {
                //console.log(index);
                var selectedResult_1 = valueResultList[index];
                handleSelectResultDirectly(selectedResult_1);
            }
        };
    }, [handleSelectResultDirectly, isShowResult, valueResultList]);
    var handleCloseResultList = react_1.useCallback(function () {
        setShowResult(false);
    }, [setShowResult]);
    var handleChange = react_1.useCallback(function (e) {
        onChange && onChange(e);
        setShowResult(true);
    }, [onChange]);
    react_1.default.useImperativeHandle(autoCompleteRef, function () { return ({
        getSelectedResult: function () { return selectedResult; }
    }); });
    return ({
        isShowResult: isShowResult,
        setShowResult: setShowResult,
        selectedResult: selectedResult,
        handleSelectResult: handleSelectResult,
        handleSelectResultDirectly: handleSelectResultDirectly,
        handleCloseResultList: handleCloseResultList,
        handleChange: handleChange,
    });
}
exports.default = useAutoComplete;
